module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/pencil-5a8b00485ccc217ee004cc30226716f1.svg";